import { render, staticRenderFns } from "./GroupOfTrainings.vue?vue&type=template&id=5389ff03"
import script from "./GroupOfTrainings.vue?vue&type=script&lang=js"
export * from "./GroupOfTrainings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports